export const UploadStatus = {
  UPLOADING: "uploading",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
  ERROR: "error",
} as const;

export type UploadStatusType = (typeof UploadStatus)[keyof typeof UploadStatus];

export interface FileUploadProgress {
  file: File;
  progress: number;
  status: UploadStatusType;
  errorMessage?: string;
  abortController?: AbortController;
}
